import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { endpoint } from './endpoints.model';
import { system_manager } from '../../assets/conf_urls.json';
import { marketsLocations } from './markets.locations.model';
import { folderSystem } from './folder.system.model';
import { AccessAuthService } from 'src/shared/access.auth.service';

@Injectable()

export class SystemProfileService {
  endpointDateToBeTransmitted = new BehaviorSubject<endpoint>(null)
  user_info_obj: any;
  adminAuthorization: boolean = false;

  constructor(private http: HttpClient,
    public accessAuthService: AccessAuthService) {
    this.accessAuthService.isAdmin.subscribe(data => this.adminAuthorization = data)

  }



  tryChangeSystemPassword(systemId: number, newPassword: string): Observable<any> {
    let json_object = {
      "id": systemId,
      "name": "system_password",
      "command": "test",
      "form_label": "Change the Admin Password",
      "secret_ops": "password_change",
      "value": newPassword
    }
    return this.http.post(system_manager.push_system_profile, json_object)
  }

  updateEndpointFolder(unitId, NewFolderId, ip): Observable<any> {
    return this.http.post(system_manager.services, {
      "event": "update_parent_id",
      "id": unitId,
      "new_parent_id": NewFolderId,
      "ip": ip
    })
  }

  pullFromSystem(unitip: string): Observable<endpoint> {
    return this.http.post<endpoint>(system_manager.pull_system_profile, {
      "system_ip": unitip
    })
  }

  deleteSystem(unitip: string): Observable<any> {
    return this.http.post<any>(system_manager.services, {
      "event": 'delete',
      "ip": unitip
    })
  }

  unprovisionSystemWithNoDelete(unitip: string): Observable<any> {
    return this.http.post<any>(system_manager.services, {
      "event": 'unprovisionSystem',
      "ip": unitip
    })
  }

  monitorOrUnmonitorSystem(flag: boolean, unitip: string): Observable<any> {
    return this.http.post<any>(system_manager.services, {
      "event": 'monitorOrUnmonitorSystem',
      "system_ip": unitip,
      "flag": flag
    })
  }

  provisionSystem(unitip): Observable<any> {
    return this.http.post<any>(system_manager.services, {
      "event": 'startProvision',
      "ip": unitip
    })
  }

  addSystems(data: {
    targetFolderId: Number,
    marketLocationId: Number,
    provisionFlag: Number,
    monitorFlag: Number,
    units: { dictId: string, system_ip: string, system_password: string }[]
  }):
    Observable<any> {
    return this.http.post<any>(system_manager.services, {
      "event": 'create',
      "data": data
    })
  }

  addNoteToSystem(unitIp: string, note: string, userName: string): Observable<endpoint> {
    return this.http.post<endpoint>(system_manager.services, {
      "event": 'addNote',
      "system_ip": unitIp,
      "note": note,
      "user_name": userName
    })
  }

  updateProfile(unitIp, swVersion, data: any[]): Observable<any> {
    return this.http.post<any>(system_manager.update_profile, {
      "system_ip": unitIp,
      "software_version": swVersion,
      "data": data
    })
  }

  getConfigFiles(unitip): Observable<string[]> {
    return this.http.post<string[]>(system_manager.services, {
      "event": 'getConfigFiles',
      "system_ip": unitip
    })
  }

  getConfigFileByName(unitip, fileName): Observable<string> {
    return this.http.post<string>(system_manager.services, {
      "event": 'getConfigFiles',
      "system_ip": unitip,
      "configFile": fileName
    })
  }

  rollbackSystemConfiguration(unitip, fileName): Observable<endpoint> {
    return this.http.post<endpoint>(system_manager.services, {
      "event": 'getConfigFiles',
      "system_ip": unitip,
      "rollbackFile": fileName
    })
  }

  getMarketsLocationsAvailable(): Observable<{ data: marketsLocations[] }> {
    return this.http.post<{ data: marketsLocations[] }>(system_manager.services, {
      "event": "select_Markets_Locations"
    })
  }

  tryInsertFirstPassword(system_ip, targetFolderId, newPassword): Observable<any> {
    return this.http.post<any>(system_manager.services, {
      "event": "insert_password_first_time",
      "system_ip": system_ip,
      "targetFolderId": targetFolderId,
      "newPassword": newPassword
    })
  }

  updateVMSPassword(system_ip, newPassword): Observable<any> {
    return this.http.post<any>(system_manager.services, {
      "event": "update_vms_password",
      "system_ip": system_ip,
      "newPassword": newPassword
    })
  }

  getSystemMarketLocation(system_ip): Observable<any> {
    return this.http.post<any>(system_manager.services, {
      "event": "get_system_market",
      "system_ip": system_ip,
    })
  }

  updateSystemMarket(system_ip, targetFolderId): Observable<any> {
    return this.http.post<any>(system_manager.services, {
      "event": "update_system_market",
      "system_ip": system_ip,
      "targetFolderId": targetFolderId
    })
  }

  getFolderSystems(targetFolderId): Observable<folderSystem[]> {
    return this.http.post<folderSystem[]>(system_manager.services, {
      "event": "get_folder_systems",
      "id": targetFolderId
    })
  }

  removeAllBackups(ip: string): Observable<any> {
    return this.http.post<any>(system_manager.services, {
      "event": "removeBackups",
      "system_ip": ip
    })
  }

  takeBackup(ip: string): Observable<any> {
    return this.http.post<any>(system_manager.services, {
      "event": "takeBackup",
      "system_ip": ip
    })
  }
}

